import React from 'react';
import { motion } from 'framer-motion';
import { EASE_OUT } from '../../utils/motion';
const PHONES = [{
  rotate: -6,
  y: 18,
  delay: 0.05
}, {
  rotate: 0,
  y: 0,
  delay: 0
}, {
  rotate: 6,
  y: 18,
  delay: 0.1
}];
export function PalacioHeroMock() {
  return <div aria-hidden className="flex aspect-[16/10] items-center justify-center gap-[3%] overflow-hidden rounded-2xl bg-ink px-6 sm:aspect-[16/8]" data-id="element-537" data-mp="1lncwzvcz7m1n">
      {PHONES.map((phone, i) => <motion.div key={i} initial={{
      opacity: 0,
      y: phone.y + 24,
      rotate: phone.rotate
    }} whileInView={{
      opacity: 1,
      y: phone.y,
      rotate: phone.rotate
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: EASE_OUT,
      delay: 0.15 + phone.delay
    }} className="aspect-[9/18] h-[78%] rounded-[22px] bg-white p-2.5 shadow-xl" data-id="element-538" data-mp="1ujkk3gjuvmuc" data-mpi={i}>
          <div className="flex h-full flex-col gap-2 rounded-[14px] bg-white" data-id="element-539" data-mp="2da3bwcwrzjr7">
            {i === 0 && <>
                <div className="h-[22%] rounded-xl bg-coral-soft" data-id="element-540" data-mp="2rng19eye5nw6" />
                <div className="h-1.5 w-2/3 rounded-full bg-line" data-id="element-541" data-mp="2ror51eru6vna" />
                <div className="grid grid-cols-2 gap-1.5" data-id="element-542" data-mp="2nkrsf79oggz7">
                  <div className="aspect-square rounded-lg bg-surface" data-id="element-543" data-mp="2imq8yl8cafn7" />
                  <div className="aspect-square rounded-lg bg-surface" data-id="element-544" data-mp="2iouef7lvzmpl" />
                </div>
                <div className="mt-auto h-[9%] rounded-lg bg-surface" data-id="element-545" data-mp="2dphqskn6ybly" />
              </>}
            {i === 1 && <>
                <div className="h-[30%] rounded-xl bg-night" data-id="element-546" data-mp="36bstc0ucymle" />
                <div className="h-1.5 w-1/2 rounded-full bg-line" data-id="element-547" data-mp="36eopbjmnb177" />
                <div className="h-1.5 w-1/3 rounded-full bg-line" data-id="element-548" data-mp="31kazdwqr5m9x" />
                <div className="h-[11%] rounded-lg bg-coral" data-id="element-549" data-mp="2wn10zrldy09y" />
                <div className="mt-auto h-[9%] rounded-lg bg-surface" data-id="element-550" data-mp="2wkoo3suhig3r" />
              </>}
            {i === 2 && <>
                <div className="h-[14%] rounded-xl bg-ink-soft" data-id="element-551" data-mp="3pa5e6jumtkwt" />
                <div className="h-[14%] rounded-xl bg-ink-soft" data-id="element-552" data-mp="1ndmtqudxlsne" />
                <div className="h-[14%] rounded-xl bg-ink-soft" data-id="element-553" data-mp="1nefzbs15mc3y" />
                <div className="mt-auto h-[9%] rounded-lg bg-surface" data-id="element-554" data-mp="1re6m7knk8837" />
              </>}
          </div>
        </motion.div>)}
    </div>;
}